import { render, staticRenderFns } from "./EntryZixu.vue?vue&type=template&id=263df514&scoped=true"
import script from "./EntryZixu.vue?vue&type=script&lang=js"
export * from "./EntryZixu.vue?vue&type=script&lang=js"
import style0 from "./EntryZixu.vue?vue&type=style&index=0&id=263df514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263df514",
  null
  
)

export default component.exports